<template>
<div class="chapter">
<div class="inner_page">
<div class="titlePage" id="tp01">
<a id="page02"></a>
<a id="page03"></a>
<a id="page04"></a>
<a id="page05"></a>
<h2 class="titlePageTitle">I, Che Guevara</h2>
<p class="titlePageSubtitle">A Novel</p>
<h2 class="titlePageAuthor">John Blackthorn</h2>
<p class="centerImage"><img alt="image" src="images/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?312d03ac